import React, { useState, useEffect } from 'react';
import { FaCoins, FaCalculator, FaChartLine, FaPiggyBank } from 'react-icons/fa';

const icons = [
    { icon: <FaCoins />, text: 'Analizando costes...' },
    { icon: <FaCalculator />, text: 'Estimando rentabilidad...' },
    { icon: <FaChartLine />, text: 'Proyectando beneficios...' },
    { icon: <FaPiggyBank />, text: 'Calculando retorno...' },
];

const InvestmentLoader = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % icons.length);
        }, 1500);

        return () => clearInterval(interval);
    }, []);

    const { icon, text } = icons[currentIndex];

    return (
        <div className="flex flex-col items-center justify-center p-6 space-y-4">
            <div className="text-4xl text-blue-600 animate-pulse">
                {icon}
            </div>
            <p className="text-gray-600 text-sm">{text}</p>
        </div>
    );
};

export default InvestmentLoader; 